import { PropsWithChildren } from "react";
import Link from "next/link";

import { ProviderHooks } from "@/src/hook";
import { StrapiComponentType } from "@/src/type/strapi";

interface VerticalNestedSwitchProps extends PropsWithChildren {
  className?: string;
  onClick?: () => void;
  cta?: StrapiComponentType.Element.Link;
}

function VerticalNestedSwitch({ className, onClick, cta, children }: VerticalNestedSwitchProps) {
  const cms = ProviderHooks.useCMS();

  const getHref = (href: string, isExternal: boolean) => {
    return isExternal ? href : cms.constructLink(href);
  };

  if (cta?.href) {
    return (
      <Link
        href={getHref(cta.href, cta.isExternal)}
        target={cta.target}
        className={className}
      >
        {children}
      </Link>
    );
  }

  return (
    <div
      className={className}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

export default VerticalNestedSwitch;
